<template>
  <span>
    <b-button @click="show">Share</b-button>
    <b-modal v-model="showModal" ok-only title="Share this deck">
      <p>
        <router-link
          :to="{
            name: 'EditVersion',
            params: { familyId: deckId, id: versionId }
          }"
        >
          This link</router-link
        >
        points to this version of the deck, whether or not this version is
        published.
      </p>
      <p>
        <router-link :to="{ name: 'EditDeck', params: { id: deckId } }">
          This link</router-link
        >
        will always point to the most recent version of the deck that the user
        has access to.
      </p>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: "ShareDeck",
  props: ["deckId", "versionId"],
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    show() {
      this.showModal = true;
    }
  }
};
</script>
